import classNames from 'classnames';
import IgnorePlayerEvents from 'src/themes/shared/components/IgnorePlayerEvents';
import styles from './styles.module.scss';

export interface IActiveOverlayProps {
  children?: React.ReactNode;
  visible: boolean;
  className?: string;
}

const ActiveOverlay = ({ children, visible, className }: IActiveOverlayProps) => (
  <div
    data-testid='active-overlay'
    className={classNames(styles.container, {
      [styles.visible]: visible,
    })}
  >
    <IgnorePlayerEvents>
      <div className={styles.content}>
        <div>{children}</div>
      </div>
    </IgnorePlayerEvents>

    <div data-testid='overlay-background' className={classNames(className, styles.overlay)} />
  </div>
);

export default ActiveOverlay;
